export default __webpack_public_path__ + "static/media/var.6fb29ac2.png";